import React from 'react';

const PILL = 'rounded-ds-pill border px-[14px] py-[7px] text-[12px] font-medium no-underline transition-colors';

/**
 * In-page chapter jumps. Sticky under the app's fixed 64px navbar, so it stays reachable through a
 * report this long.
 */
const ChapterNav = () => (
  <nav
    className='sticky top-16 z-[9] m-0 mt-[22px] flex flex-wrap items-center gap-1 py-[10px]'
    style={{ background: 'linear-gradient(#F9FAFB 78%, rgba(249,250,251,0))' }}
  >
    <a
      href='#benchmarks'
      className={`${PILL} border-gray-300 bg-white text-gray-700 hover:border-gray-400 hover:text-gray-900`}
    >
      <span className='mr-[7px] font-jetbrains-mono text-gray-400'>01</span>
      Industry benchmarks
    </a>
    <a
      href='#ch1'
      className={`${PILL} border-gray-300 bg-white text-gray-700 hover:border-gray-400 hover:text-gray-900`}
    >
      <span className='mr-[7px] font-jetbrains-mono text-gray-400'>02</span>
      Metabolic syndrome risk
    </a>
    <a
      href='#ch2'
      className={`${PILL} border-gray-300 bg-white text-gray-700 hover:border-gray-400 hover:text-gray-900`}
    >
      <span className='mr-[7px] font-jetbrains-mono text-gray-400'>03</span>
      Deficiency &amp; anaemia risk
    </a>
    <a
      href='#caveat'
      className={`${PILL} border-ds-amber-200 bg-ds-amber-lt text-ds-amber-dk hover:border-ds-amber`}
    >
      Read the data caveat
    </a>
  </nav>
);

export default ChapterNav;
